import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Dropdown, Flag, F } from 'nallian-shared-ui/lib/components';
import countriesService from '../services/countriesService';

const splitOption = [
  { value: '-', key: '-', text: '---', content: <Dropdown.Divider />, disabled: true },
];
const emptyArray = [];

const mapOption = item => ({
  key: item.id,
  value: item.id,
  text: item.name,
  content: (
    <Fragment>
      <Flag name={item.id} /> {item.name}
    </Fragment>
  ),
});

const CountriesSelect = ({ t, countriesFetch, input, label, ...props }) => (
  <F.Select
    placeholder={t('country')}
    selectOnBlur={false}
    options={(countriesFetch.value || emptyArray)
      .filter(item => item.isPreferred)
      .map(mapOption)
      .concat(splitOption)
      .concat(
        (countriesFetch.value || emptyArray).filter(item => !item.isPreferred).map(mapOption)
      )}
    name="countryCode"
    loading={countriesFetch.pending}
    onChange={(_, data) => input.onChange(data.value)}
    value={(input && input.value) || ''}
    search
    {...props}
  />
);

CountriesSelect.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  vehicleTypesFetch: PropTypes.object.isRequired,
  countriesFetch: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  dispatchCountriesGet: PropTypes.func.isRequired,
  label: PropTypes.string,
};

CountriesSelect.defaultProps = {
  label: undefined,
};

export default compose(
  withTranslation(),
  countriesService
)(CountriesSelect);
